import type { ColumnTypeFn } from "../types";

export const booleanType: ColumnTypeFn = (value) =>
  value ? (
    <i className="fas fa-check text-success" />
  ) : (
    <i className="fas fa-times text-danger" />
  );
